import * as React from 'react';

class Question extends React.Component {

    render() {
        return (
                <ol className="question-list">
                    {this.props.questions.map((info, key) => <li id={info.Id} key={info.Id} onClick={this.handleClick} className={info.highlight ? "selected": "not-selected"}>{info.Question}</li>)}
                </ol>

        );
    }
}

export default Question;



// WEBPACK FOOTER //
// ./src/components/Question.js